/* =========================================================
   Beato Custom Package Bundle — NEW JS (isolated, all selectors use -new suffix)
   Original source: beato-custom-package-bundle.js (GLP-New-Theme)
   ========================================================= */
(function () {
  'use strict';

  function initAccordionNew(acc) {
    var trigger = acc.querySelector('[data-accordion-new-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var isOpen = acc.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initNew(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-accordion-new]');
    items.forEach(initAccordionNew);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initNew(); });
  } else {
    initNew();
  }

  // Re-init on Shopify theme editor events
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initNew(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var acc = e.target.closest('[data-accordion-new]');
      if (acc && !acc.classList.contains('is-open')) {
        acc.classList.add('is-open');
        var trigger = acc.querySelector('[data-accordion-new-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }
})();
